import { SET_LOCATION_GROUPS } from './chunk-EMTYXPW7.mjs';
import { BASE_STORE_INITIAL_STATE } from './chunk-7PCIVIEC.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/state/locations/reducers.ts
var LOCATION_INITIAL_STORE = __spreadProps(__spreadValues({}, BASE_STORE_INITIAL_STATE), {
  organizationId: 0,
  locationGroupId: 0,
  name: "",
  streetLine1: "No street",
  streetLine2: "No street",
  city: "---",
  state: "---",
  postalCode: "---",
  country: "---",
  phoneNumber: "",
  email: ""
});
var LOCATIONS_INITIAL_STATE = {
  0: {
    name: "",
    createdAt: "",
    updatedAt: "",
    deletedAt: null,
    id: 0,
    organizationId: 0,
    locations: [LOCATION_INITIAL_STORE]
  }
};
var locationsReducer = (state = LOCATIONS_INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SET_LOCATION_GROUPS:
      return payload;
    default:
      return state;
  }
};
var reducers_default = locationsReducer;

export { LOCATION_INITIAL_STORE, reducers_default };
